import { ChangeDetectorRef, Component, HostBinding, OnChanges, OnDestroy, OnInit, SimpleChanges, signal } from '@angular/core';
import { Router } from '@angular/router';

import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { Subscription } from 'rxjs';

import { TreeItem } from '../../../../common/item/item.model';
import { GreyhoundMeetingSwitcherService } from '../../../common/greyhound-meeting-switcher-service';
import { DayofRaceComponent } from '../../tournaments/day-of-race-lobby.component';

export interface MeetingTreeState {
    region?: number;
    regionExpanded?: (string | number)[];
    context?: string;
}

@Component({
    selector: 'ms-greyhounds-meeting-switcher',
    templateUrl: 'greyhounds-meeting-switcher.html',
    standalone: false,
})
export class GreyhoundsMeetingSwitcherComponent extends DayofRaceComponent implements OnInit, OnChanges, OnDestroy {
    tree: TreeItem;
    @HostBinding('class') className = 'competition-tree gh-meeting-switcher';
    routerEventsSubscription: Subscription;
    trackingValue = signal<string>('M2_ListItemlinks');
    cleanedAfterTrack = signal(false);

    constructor(
        private ghSwitcherService: GreyhoundMeetingSwitcherService,
        private routerEvents: RouterEventsService,
        private router: Router,
        private trackingService: TrackingService,
        private changeDetection: ChangeDetectorRef,
        urlHelper: UrlHelperService,
    ) {
        super(urlHelper);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.tree = this.ghSwitcherService.buildMeetingTree(this.vm, this._filter);
    }

    ngOnInit(): void {
        this.routerEventsSubscription = this.routerEvents.currentRoutesRecognized.subscribe((event) => {
            if (event) {
                const url = event.urlAfterRedirects || event.url || this.router.url;
                const fixtureId = this.ghSwitcherService.getFixtureId(url);
                const hasFixtureId = this.vm.regions.some((o) =>
                    o.meetings.some((m) => m.fixtures.some((f) => f.fixtureId === fixtureId.toString())),
                );
                this.tree = this.ghSwitcherService.setFixtureSelection(url, this.tree, this._filter, hasFixtureId);
                this.changeDetection.markForCheck();
            }
        });
    }

    ngOnDestroy() {
        this.routerEventsSubscription?.unsubscribe();
    }

    getDayOfRace() {
        return this._filter;
    }

    onTreeItemClick(item: TreeItem) {
        this.cleanedAfterTrack.update(() => item.href?.indexOf('http') === 0 || false);
        this.tree = this.ghSwitcherService.enableClick(this.tree, Number(item.id));
        const regionName = this.ghSwitcherService.getRegionName(this.tree, item);
        this.tracking(item.title, regionName ?? '', item.href ?? '', this._filter.toLowerCase());
    }

    toggled(tree: TreeItem, item: TreeItem): void {
        if (tree === this.tree) {
            this.tree = this.ghSwitcherService.toggleExpanded(tree, item);
        }
    }

    tracking(meetingName: string, region: string, url: string, routepath: string) {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Greyhounds',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'sub navigation',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: meetingName,
            [trackingConstants.COMPONENT_POSITION_EVENT]: routepath,
            [trackingConstants.COMPONENT_URL_CLICKED]: url,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: region,
        });
    }
}
